<template>
  <div class="container-fluid">
    <v-data-table
      :headers="headers"
      :items="foods"
      sort-by="internalName"
      class="elevation-1"
      :search="search"
      :items-per-page="-1"
      locale="cs"
      :loading="loading"
    >
      <template v-slot:top>
        <v-card
          color="red"
          flat
          tile
        >
          <v-toolbar dense
                     src="https://www.arcgis.com/sharing/rest/content/items/8f762395cd204552bb958ecb1b54339d/resources/1588745514029.jpeg?w=2932"
          >
            <v-spacer></v-spacer>
            <v-dialog
            v-model="dialog"
            width="800"
            persistent
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="white"
                  dark
                  outlined
                  v-bind="attrs"
                  v-on="on"
                  class="black--text"
                  @click="editedItem = defaultItem"
                >
                  Přidat jídlo
                </v-btn>
              </template>
              <FoodForm
                @formCanceled="dialog = false"
                :item="editedItem"
                v-if="dialog"
                @data-saved="getFood"
                :food-types="availableFoodTypes"
                :time-types="availableTimeTypes"
                :alergens="availableAlergens"
              ></FoodForm>
            </v-dialog>
          </v-toolbar>
        </v-card>
        <v-toolbar flat color="white">
          <v-toolbar-title>Databáze jídel</v-toolbar-title>
          <v-divider
            class="mx-4"
            inset
            vertical
          ></v-divider>
          <v-spacer>Výpis</v-spacer>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Vyhledávání"
            single-line
            hide-details
          ></v-text-field>
        </v-toolbar>
      </template>
      <template v-slot:item.specialOffer="{ item }">
        {{item.specialOffer ? 'Ano' : 'Ne' }}
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon
          small
          class="mr-2"
          @click="editItem(item)"
        >
          mdi-pencil
        </v-icon>
        <v-icon
          small
          class="mr-2"
          @click="duplicateItem(item)"
        >
          mdi-content-copy
        </v-icon>
        <v-icon
          small
          class="mr-2"
          @click="archive(item)"
        >
          mdi-archive-arrow-down
        </v-icon>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="getFood">Reset</v-btn>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import FoodForm from '../../components/forms/admin/FoodForm'
export default {
  Name: 'FoodDatabase',
  components: { FoodForm },
  data: () => ({
    availableFoodTypes: [],
    availableTimeTypes: [],
    availableAlergens: [],
    search: '',
    dialog: false,
    editedItem: {},
    foods: [],
    loading: true,
    defaultItem: {
      id: null,
      active: true,
      internalName: '',
      name: '',
      foodTypes: [],
      timeTypes: [],
      alergens: [],
      price: '',
      weight: '',
      calories: '',
      specialOffer: false
    },
    headers: [
      {
        text: 'Interní název',
        align: 'start',
        sortable: true,
        value: 'internalName'
      },
      { text: 'Název jídla', value: 'name' },
      { text: 'Typ stravy', value: 'typesStr' },
      { text: 'Denní doba', value: 'timesStr' },
      { text: 'Alergeny', value: 'alergensStr' },
      { text: 'Cena', value: 'price' },
      { text: 'Hmostost', value: 'weight' },
      { text: 'Kalorie', value: 'calories' },
      { text: 'Speciální nabídka', value: 'specialOffer' },
      { text: 'Akce', value: 'actions', sortable: false }
    ]
  }),
  created () {
    this.initialize()
    this.getFood()
  },

  methods: {
    initialize () {
      this.$http.get('/admin/alergens')
        .then(response => {
          this.availableAlergens = this.keysToCamelCase(response.data)
            .filter(alergen => alergen.active)
        })
      this.$http.get('/admin/food-types')
        .then(response => {
          this.availableFoodTypes = this.keysToCamelCase(response.data)
            .filter(type => type.active)
        })
      this.$http.get('/times')
        .then(response => {
          this.availableTimeTypes = this.keysToCamelCase(response.data)
            .filter(time => time.active)
        })
    },
    getFood () {
      this.foods = []
      this.loading = true
      this.dialog = false
      this.$http.get('/admin/foods')
        .then(response => {
          this.foods = this.keysToCamelCase(response.data)
            .filter(item => item.visible)
            .map(food => {
              food.timesStr = food.timeTypes
                .map(time => time.name)
                .join(', ')
              food.typesStr = food.foodTypes
                .map(type => type.name)
                .join(', ')
              food.alergensStr = food.alergens
                .map(alergen => alergen.name)
                .join(', ')
              return food
            })
          this.loading = false
        })
    },
    editItem (item) {
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },
    duplicateItem (item) {
      this.editedItem = Object.assign({}, item)
      this.editedItem.id = null
      this.dialog = true
    },
    archive (item) {
      this.$http.post(`admin/foods/${item.id}/archive`)
        .then(() => {
          this.getFood()
        })
    }
  }
}
</script>

<style scoped>

</style>
